import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=9daa9090&scoped=true&"
import script from "./StandardLayout.vue?vue&type=script&lang=ts&"
export * from "./StandardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StandardLayout.vue?vue&type=style&index=0&id=9daa9090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daa9090",
  null
  
)

component.options.__file = "StandardLayout.vue"
export default component.exports